/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceAuthenticationDeviceFragment = { id: string, virtual: boolean, isDeviceNode: 'Device', description: { model: string, features: { name: { supported: boolean }, authentication: { supported: boolean } } }, features: { name: { name: string } | null, authentication: { credentials: Array<{ credentialsState: Types.CredentialsState, accessLevel: string }> | null } | null, controlNetwork: { interface: { ipAddress: string | null } } | null } };

export type DeviceAuthenticationDeviceUpdateFragment = { id: string, features:
    | { authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null }
    | { name: { name: string } | null }
    | Record<PropertyKey, never>
   };

export type GetDevicesQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type GetDevicesQueryOpResult = { nodes: Array<
    | DeviceAuthenticationDeviceFragment
    | Record<PropertyKey, never>
   | null> };

export type DeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type DeviceSubscriptionOpResult = { nodeChanges:
    | DeviceAuthenticationDeviceFragment
    | DeviceAuthenticationDeviceUpdateFragment
    | Record<PropertyKey, never>
   };

export const DeviceAuthenticationDeviceFragment = gql`
    fragment DeviceAuthenticationDeviceFragment on Device {
  isDeviceNode: __typename
  id
  virtual
  description {
    model
    features {
      name {
        supported
      }
      authentication {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    authentication {
      credentials {
        credentialsState
        accessLevel
      }
    }
    controlNetwork {
      interface {
        ipAddress
      }
    }
  }
}
    `;
export const DeviceAuthenticationDeviceUpdateFragment = gql`
    fragment DeviceAuthenticationDeviceUpdateFragment on DeviceChange {
  id
  features {
    ... on DeviceNameChange {
      name {
        name
      }
    }
    ... on DeviceAuthenticationChange {
      authentication {
        credentials {
          accessLevel
          credentialsState
        }
      }
    }
  }
}
    `;
export const GetDevicesQueryDocument = gql`
    query GetDevicesQuery($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...DeviceAuthenticationDeviceFragment
  }
}
    ${DeviceAuthenticationDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDevicesQueryGQL extends Apollo.Query<GetDevicesQueryOpResult, GetDevicesQueryVariables> {
    override document = GetDevicesQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeviceSubscriptionDocument = gql`
    subscription DeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceAuthenticationDeviceFragment
    ...DeviceAuthenticationDeviceUpdateFragment
  }
}
    ${DeviceAuthenticationDeviceFragment}
${DeviceAuthenticationDeviceUpdateFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeviceSubscriptionGQL extends Apollo.Subscription<DeviceSubscriptionOpResult, DeviceSubscriptionVariables> {
    override document = DeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }